
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import TcclUpload from "../components/tcclUpload";
import Footer from "../components/footer";

function TcclUploadPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <TcclUpload /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default TcclUploadPage;
